import React, { useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Grid, Stack } from '@mui/material';
import { useForm } from 'react-hook-form';
import { CVHttpService } from '../../services';

function ReferenceFormDialog({ open, onClose, onSave, cvId, reference }) {
    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        defaultValues: reference || {
            name: '',
            position: '',
            location: '',
            email: '',
            phone_number: ''
        }
    });

    useEffect(() => {
        if (open) {
            if (reference) {
                reset({
                    name: reference.name || '',
                    position: reference.position || '',
                    location: reference.location || '',
                    email: reference.email || '',
                    phone_number: reference.phone_number || ''
                });
            } else {
                reset({
                    name: '',
                    position: '',
                    location: '',
                    email: '',
                    phone_number: ''
                });
            }
        }
    }, [reference, open, reset]);

    const onSubmit = async (data) => {
        try {
            const body = {
                ...data,
                id: reference?.id || null,
                cv: cvId,
                user: null
            };
            await CVHttpService.saveReference(body);
            onSave();
        } catch (err) {
            alert('Failed to save reference');
            console.error(err);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>{reference ? 'Edit Reference' : 'Add Reference'}</DialogTitle>
                <DialogContent>
                    <Stack spacing={3} sx={{ mt: 1 }}>
                        <TextField
                            fullWidth
                            label="Full Name *"
                            {...register('name', { required: 'Name is required' })}
                            error={!!errors.name}
                            helperText={errors.name?.message}
                        />
                        <TextField
                            fullWidth
                            label="Position/Title"
                            {...register('position')}
                            placeholder="e.g., Senior Software Engineer, HR Manager"
                        />
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Email"
                                    type="email"
                                    {...register('email')}
                                    placeholder="email@example.com"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Phone Number"
                                    {...register('phone_number')}
                                    placeholder="+1 234 567 8900"
                                />
                            </Grid>
                        </Grid>
                        <TextField
                            fullWidth
                            label="Location"
                            {...register('location')}
                            placeholder="e.g., New York, USA"
                        />
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button type="submit" variant="contained">Save</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}

export default ReferenceFormDialog;

